// ABOUTME: The one place the CV builder picks its CV API: pro-core's (./api), or the mock layer's in a dev build that
// ABOUTME: names `cv` in VITE_MOCK_API. The lookup lists (universities, skills…) always come from pro-core.
import { mockRegistry } from 'mocks/registry';
import * as api from './api';

export const cvApi: typeof api = mockRegistry.apis.cv ?? api;
